<template>
  <div class="form-wrapper">
    <div class="form-container">
      <div class="login-header">
        <img :src="logo" alt="Click and Plan God" class="login-logo" />
        <h2>Panel de Administración</h2>
        <p class="login-subtitle">Introduce tus credenciales para acceder a God</p>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Usuario</label>
          <input
            id="username"
            v-model="username"
            type="text"
            placeholder="Introduce tu usuario"
            required
            autocomplete="username"
          />
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="••••••••"
            required
            autocomplete="current-password"
          />
        </div>

        <button class="main_button w-full submit-btn" type="submit" :disabled="loadingStore.isLoading">
          <span v-if="loadingStore.isLoading">Iniciando sesión...</span>
          <span v-else>Iniciar Sesión</span>
        </button>
      </form>
    </div>

    <p class="footer-copy">© Click and Plan — Dashboard God</p>
    <ErrorPopup :errorMessage="error" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import { useLoadingStore } from "@/stores/loadingStore";
import ErrorPopup from "@/components/common/ErrorPopup.vue";

const username = ref("");
const password = ref("");
const error = ref(null);
const logo = require("@/assets/images/logo.png");
const router = useRouter();
const loadingStore = useLoadingStore();

const handleLogin = async () => {
  loadingStore.setLoading(true);
  error.value = null;

  try {
    const response = await fetch(process.env.VUE_APP_API_URL+"api/god/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
      },
      body: JSON.stringify({
        "user": username.value,
        "password": password.value,
      }),
    });

    if (!response.ok) {
      error.value = "Error en la autenticación";
    }

    const data = await response.json();

    if (data.errors) {
      error.value = data.message;
    } else {
      error.value = null;
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("token", data.user_token);
      router.push("/home");
    }
  } catch (exception) {
    error.value = exception.message;
  } finally {
    loadingStore.setLoading(false);
  }
};
</script>

<style scoped>
.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-logo {
  width: 100%;
  max-width: 220px;
  height: auto;
  margin-bottom: 1.25rem;
}

.login-header h2 {
  font-size: 1.5rem;
  margin-bottom: 0.35rem;
  color: var(--text-color-dark);
}

.login-subtitle {
  font-size: 0.875rem;
  color: var(--text-color-light);
  margin-bottom: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  text-align: left;
}

label {
  font-size: 0.825rem;
  font-weight: 600;
  color: var(--text-color-dark);
}

.submit-btn {
  margin-top: 0.5rem;
  height: 44px;
  font-size: 14px;
}

.footer-copy {
  margin-top: 2rem;
  font-size: 0.8rem;
  color: var(--text-color-light);
}
</style>
